import { getProductPathBySku } from "../queries/getProductPathBySku.search.js";
import { getProductByPath } from "../queries/getProductByPath.catalogue.js";
export const fetchAllProductVariantsBySku = async (skus, { client }) => {
    const searchResult = await getProductPathBySku({ skus }, { client });
    const productQueryResults = await Promise.all((searchResult ?? []).map((product) => {
        return getProductByPath({ path: product.path }, {
            client,
        });
    }));
    const products = productQueryResults.reduce((acc, cur) => [...acc, cur], []);
    return products;
};
export const fetchProductBySku = async (sku, { client }) => {
    const products = await fetchAllProductVariantsBySku([sku], { client });
    const product = products.find(({ variants }) => variants?.some((variant) => variant.sku === sku));
    return { ...product, variants: product?.variants };
};
